import type { MantineTheme } from '@mantine/core';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const asNumber = (value: unknown): number =>
  typeof value === 'number' && Number.isFinite(value) ? value : 0;

export type DemographicCounts = Record<string, number>;

export const demographicLabelOverrides: Record<string, string> = {};

export const getDemographicLabel = (key: string): string => demographicLabelOverrides[key] ?? key;

export const toDemographicCounts = (value: unknown): DemographicCounts => {
  if (!isPlainObject(value)) return {};
  return Object.fromEntries(Object.entries(value).map(([key, raw]) => [key, asNumber(raw)]));
};

export const demographicKeys = (...records: DemographicCounts[]): string[] => {
  const keys = new Set<string>();
  records.forEach((record) => Object.keys(record).forEach((key) => keys.add(key)));
  return Array.from(keys);
};

const DIVERSE_THEME_COLORS = [
  'blue',
  'orange',
  'teal',
  'grape',
  'lime',
  'red',
  'cyan',
  'yellow',
  'pink',
  'indigo',
] as const;

export const getDemographicColor = (theme: MantineTheme, index: number): string =>
  theme.colors[DIVERSE_THEME_COLORS[index % DIVERSE_THEME_COLORS.length]][6];
